import { render, staticRenderFns } from "./EditorHealthImageDialog.vue?vue&type=template&id=20707204&scoped=true"
import script from "./EditorHealthImageDialog.vue?vue&type=script&lang=js"
export * from "./EditorHealthImageDialog.vue?vue&type=script&lang=js"
import style0 from "./EditorHealthImageDialog.vue?vue&type=style&index=0&id=20707204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20707204",
  null
  
)

export default component.exports